import type { RouteRecordRaw } from 'vue-router';

export const clinicRoutes: RouteRecordRaw[] = [
  {
    path: '/clinic/login',
    name: 'ClinicLogin',
    component: () => import('@/components/views/clinic/Login.vue'),
    meta: { title: 'ログイン' },
  },
  {
    path: '/clinic',
    component: () => import('@/components/layouts/clinic/ClinicLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: { name: 'EstimatePatientList' },
      },
      {
        path: 'users',
        name: 'UserList',
        component: () => import('@/components/views/clinic/UserList.vue'),
        meta: { title: '患者一覧' },
      },
      {
        path: 'users/:id',
        name: 'UserDetail',
        component: () => import('@/components/views/clinic/UserDetail.vue'),
        meta: { title: '患者詳細' },
        props: true,
      },
      {
        path: 'estimates',
        name: 'EstimatePatientList',
        component: () => import('@/components/views/clinic/EstimatePatientList.vue'),
        meta: { title: '患者検索' },
      },
      {
        path: 'estimates/new',
        name: 'EstimateCreate',
        component: () => import('@/components/views/clinic/EstimateEdit.vue'),
        meta: { title: '見積書作成' },
      },
      {
        path: 'estimates/patient/:patientId',
        name: 'EstimateList',
        component: () => import('@/components/views/clinic/EstimateList.vue'),
        meta: { title: '見積一覧' },
        props: true,
      },
      {
        path: 'estimates/:id/edit',
        name: 'EstimateEdit',
        component: () => import('@/components/views/clinic/EstimateEdit.vue'),
        meta: { title: '見積書編集' },
        props: true,
      },
      {
        path: 'consultings',
        name: 'ConsultingPatientList',
        component: () => import('@/components/views/clinic/ConsultingPatientList.vue'),
        meta: { title: 'コンサルティング患者一覧' },
      },
      {
        path: 'contracts',
        name: 'ContractPatientList',
        component: () => import('@/components/views/clinic/ContractPatientList.vue'),
        meta: { title: '契約患者一覧' },
      },
      {
        path: 'contracts/patient/:patientId',
        name: 'ContractList',
        component: () => import('@/components/views/clinic/ContractList.vue'),
        meta: { title: '契約一覧' },
        props: true,
      },
      {
        path: 'contracts/:id',
        name: 'ContractDetail',
        component: () => import('@/components/views/clinic/ContractDetail.vue'),
        meta: { title: '契約詳細' },
        props: true,
      },
      {
        path: 'payments',
        name: 'PaymentList',
        component: () => import('@/components/views/clinic/PaymentList.vue'),
        meta: { title: '入金管理' },
      },
      {
        path: 'prices',
        redirect: { name: 'MenuPriceList' },
      },
      {
        path: 'prices/list',
        name: 'MenuPriceList',
        component: () => import('@/components/views/clinic/PriceList.vue'),
        meta: { title: '価格一覧表' },
      },
      {
        path: 'prices/categories',
        name: 'CategoryManagement',
        component: () => import('@/components/views/clinic/CategoryManagement.vue'),
        meta: { title: 'カテゴリ設定' },
      },
      {
        path: 'prices/manage',
        name: 'PriceManagement',
        component: () => import('@/components/views/clinic/PriceSettings.vue'),
        meta: { title: '価格設定' },
      },
      {
        path: 'prices/product-menus',
        name: 'ProductMenuSettings',
        component: () => import('@/components/views/clinic/ProductMenuSettings.vue'),
        meta: { title: '商品メニュー設定' },
      },
      {
        path: 'prices/special-time-discounts',
        name: 'SpecialTimeDiscounts',
        component: () => import('@/components/views/clinic/SpecialTimeDiscounts.vue'),
        meta: { title: '特別時間割引' },
      },
      {
        path: 'prices/gender-discounts',
        name: 'GenderDiscounts',
        component: () => import('@/components/views/clinic/GenderDiscounts.vue'),
        meta: { title: '性別割引' },
      },
      {
        path: 'prices/nationality-discounts',
        name: 'NationalityDiscounts',
        component: () => import('@/components/views/clinic/NationalityDiscounts.vue'),
        meta: { title: '国籍割引' },
      },
      {
        path: 'prices/age-discounts',
        name: 'AgeDiscounts',
        component: () => import('@/components/views/clinic/AgeDiscounts.vue'),
        meta: { title: '年齢割引' },
      },
      {
        path: 'settings',
        name: 'ClinicSettings',
        component: () => import('@/components/views/clinic/Settings.vue'),
        meta: { title: '設定' },
      },
      {
        path: 'setting-dashboard',
        name: 'ClinicSettingDashboard',
        component: () => import('@/components/views/clinic/Settings.vue'),
        meta: { title: '設定ダッシュボード' },
      },
      {
        path: 'staff',
        name: 'StaffList',
        component: () => import('@/components/views/clinic/StaffList.vue'),
        meta: { title: 'スタッフ管理' },
      },
      {
        path: 'info',
        name: 'ClinicInfo',
        component: () => import('@/components/views/clinic/ClinicInfo.vue'),
        meta: { title: 'クリニック情報' },
      },
      {
        path: 'bank-account',
        name: 'ClinicBankAccount',
        component: () => import('@/components/views/clinic/BankAccount.vue'),
        meta: { title: '振込口座設定' },
      },
      {
        path: 'system-settings',
        name: 'ClinicSystemSettings',
        component: () => import('@/components/views/clinic/SystemSettings.vue'),
        meta: { title: '設定' },
      },
      {
        path: 'notifications',
        name: 'NotificationList',
        component: () => import('@/components/views/clinic/NotificationList.vue'),
        meta: { title: '通知メニュー' },
      },
      {
        path: 'notifications/:id',
        name: 'NotificationDetail',
        component: () => import('@/components/views/clinic/NotificationDetail.vue'),
        meta: { title: '通知詳細' },
        props: true,
      },
    ],
  },
];
